import { ImageBackground, StyleSheet, View } from 'react-native'
import { parse, useURL } from 'expo-linking'
import { useEffect, useMemo, useState } from 'react'
import { useConfigProvider } from 'components/provider/ConfigProvider'
import { configKeys } from 'utils/config/keys'
import HelperDomain from 'utils/helper-domain'
import { useSplash } from 'components/provider/SplashProvider'
import LoadingComponent from 'components/atoms/Loading'
import { layoutStyles } from 'styles/layout'
import EmailResponse from 'scenes/response/components/Response'
import WebContainerView from 'components/atoms/WebContainerView'
import BackgroundImage from 'assets/response_bg.jpg'

const ResponseIndex = () => {
	
	const config = useConfigProvider()
	const { fadeOutSplash, splashVisible, logout } = useSplash()
	
	const url = useURL()
	const [ parsedUrl, setParsedUrl ] = useState( null )
	
	const [ type, setType ] = useState( null )
	const [ customer, setCustomer ] = useState( null )
	const [ guid, setGuid ] = useState( null )
	
	const configSettings = async () => {
		if( parsedUrl === null ) {
			return;
		}
		
		// Split the url
		const split = parsedUrl?.path.split('/')

		// Get the data from the split
		const [ type, customer, guid ] = split;
		
		// Set it all
		setType( type )
		setCustomer( customer )
		setGuid( guid )
		
		// Create a valid domain name
		const validDomain = HelperDomain.valid( customer );
		
		// Set the customer id in the settings
		await config.call( 'set', configKeys.CUSTOMER_ID, validDomain )
		
		// Remove the splash screen
		fadeOutSplash();
	}
	
	useEffect( () => {
		if( url !== null ) {
			setParsedUrl( parse( url ) )
		}
	}, [ url ] );
	
	useEffect( () => {
		configSettings()
	}, [ parsedUrl ] );
	
	const content = useMemo( () => {
		switch( type ) {
			case 'response':
				return (
					<EmailResponse guid={ guid } />
				)
		}
		
		return (
			<LoadingComponent />
		)
	}, [ type, customer, guid ] )
	
	return (
		<ImageBackground
			source={ BackgroundImage }
			resizeMode={ 'cover' }
			style={ styles.body }>
			
			<WebContainerView
				containerStyle={ styles.responseContainer }
				style={ styles.response }>
				
				<View
					style={[ layoutStyles.flexOne, styles.content ]}>
					
					{ content }
				</View>
			</WebContainerView>
		</ImageBackground>
	)
}

const styles = StyleSheet.create({
	body: {
		backgroundColor: 'green',
		width: '100%',
		height: '100%',
		flex: 1,
	},
	responseContainer: {
		backgroundColor: 'rgba( 240, 163, 63, 0.89 )',
	},
	response: {
		borderWidth: 0,
		borderRadius: 0
	},
	content: {
		//backgroundColor: '#fff',
	},
})

export default ResponseIndex;
